import React, { ReactNode } from "react";
import { SettingsProvider } from "./SettingsContext";
import NotificationProvider from "./NotificationContext";
import { FileUploadProvider } from "./FileUploadContext";
import { CuratorInformationProvider } from "./CuratorInformation";
import { CuratorConversationsProvider } from "./CuratorConversationsContext";

interface ContextProviderProps {
  children: ReactNode;
}

const ContextProvider: React.FC<ContextProviderProps> = ({ children }) => {
  return (
    <NotificationProvider>
      <SettingsProvider>
        <FileUploadProvider>
          <CuratorInformationProvider>
            <CuratorConversationsProvider>
              {children}
            </CuratorConversationsProvider>
          </CuratorInformationProvider>
        </FileUploadProvider>
      </SettingsProvider>
    </NotificationProvider>
  );
};

export default ContextProvider;
